module.exports = __webpack_public_path__ + "static/media/bts_boots_170817_010_small.cd9ed155.jpg";